exports = module.exports = require("../../../../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-wrapper[data-v-425f8946] {\n  min-height: calc(100vh - 571px);\n}\n.table-wrapper .table-wrapper-table[data-v-425f8946] {\n    margin-top: 10px;\n}\n.table-wrapper .table-page-wrapper[data-v-425f8946] {\n    padding-top: 14px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: reverse;\n        -ms-flex-direction: row-reverse;\n            flex-direction: row-reverse;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?{"sourceMap":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-425f8946","scoped":true,"hasInlineConfig":false}!./node_modules/_sass-loader@6.0.7@sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/views/personal/order/components/orderTable/index.vue
// module id = Fd+t
// module chunks = 1